module.exports = __webpack_public_path__ + "static/media/team-dan.aaef33db.jpg";